// This file is autogenerated. DO NOT MODIFY

/* eslint-disable unicorn/prevent-abbreviations */

export interface IEoraColours {
  BASE: IEoraColoursBASE;
  CORE: Core;
  BRAND: { [key: string]: BRANDValue };
}

export interface IEoraColoursBASE {
  VALUE: Value;
}

export interface Value {
  COLOR: Color;
}

export interface Color {
  OPAQUE_BLUES: OpaqueBlues;
  STATUS_COLORS: ColorStatusColors;
  BRAND: ColorBrand;
  GRAY: Gray;
  BASE: ColorBase;
  MISC: Shadows;
  TRADING: Trading;
}

export interface ColorBase {
  WHITE: string;
  BLACK: string;
}

export interface ColorBrand {
  CMC_ONLY: CmcOnly;
  WL_COLORS: { [key: string]: string };
}

export interface CmcOnly {
  CMC_COBALT: string;
  CMC_CORAL: string;
  CMC_GREY_FOUNDATION: string;
}

export interface Gray {
  GRAY_05: string;
  GRAY_15: string;
  GRAY_25: string;
  GRAY_35: string;
  GRAY_50: string;
  GRAY_100: string;
  GRAY_200: string;
  GRAY_300: string;
  GRAY_400: string;
  GRAY_500: string;
  GRAY_600: string;
  GRAY_700: string;
  GRAY_800: string;
  GRAY_900: string;
}

export interface Shadows {
  YELLOW?: string;
  SHADOW_SOFT: string;
  SHADOW_DEFAULT: string;
  SHADOW_STRONG: string;
  SHADOW_XSTRONG: string;
  Z_IGNORE?: ZIgnore;
}

export interface ZIgnore {
  XS_IGNORE: string;
}

export interface OpaqueBlues {
  BLUE_500_OPACITY_50: string;
  BLUE_500_OPACITY_70: string;
}

export interface ColorStatusColors {
  ORANGE: Orange;
  BLUE: Blue;
  RED: Red;
  GREEN: Green;
}

export interface Blue {
  BLUE_25: string;
  BLUE_50: string;
  BLUE_400: string;
  BLUE_500: string;
  BLUE_600: string;
  BLUE_700: string;
  BLUE_800: string;
}

export interface Green {
  GREEN_25: string;
  GREEN_50: string;
  GREEN_200: string;
  GREEN_400: string;
  GREEN_500: string;
  GREEN_600: string;
  GREEN_700: string;
  GREEN_800: string;
}

export interface Orange {
  ORANGE_25: string;
  ORANGE_50: string;
  ORANGE_400: string;
  ORANGE_500: string;
  ORANGE_600: string;
  ORANGE_700: string;
  ORANGE_800: string;
}

export interface Red {
  RED_800: string;
  RED_25: string;
  RED_50: string;
  RED_400: string;
  RED_500: string;
  RED_600: string;
  RED_700: string;
}

export interface Trading {
  TRADING_RED: string;
  TRADING_GREEN: string;
  TRADING_GREEN_DARK: string;
  TRADING_RED_DARK: string;
  TRADING_RED_DARKMODE: string;
  TRADING_GREEN_DARKMODE: string;
  TRADING_GREEN_DARKMODE_DARK: string;
  TRADING_RED_DARKMODE_DARK: string;
}

export interface BRANDValue {
  BRAND_CMC_ONLY_COLORS: BrandCmcOnlyColors;
  BRAND_WL_COLORS: BrandBrandWlColors;
  DARK: BrandDark;
  LIGHT: BrandDark;
  BRAND_FOCUS_RING: BrandFocusRing;
  OUTLINE_MINIMAL_BTN_OVERRIDES: OutlineMinimalBtnOverrides;
}

export interface BrandCmcOnlyColors {
  CMC_COLOR_COBALT: string;
  CMC_COLOR_CORAL: string;
  CMC_COLOR_GRAYFOUNDATION: string;
}

export interface BrandFocusRing {
  WL_COLOR_FOCUSRING: string;
}

export interface BrandBrandWlColors {
  WL_COLOR_PRIMARY: string;
  WL_COLOR_ACCENT: string;
  WL_COLOR_BUTTON_TEXT_LINK_PRIMARY?: string;
  WL_COLOR_BUTTON_TEXT_LINK_ACCENT: string;
  WL_COLOR_HYPERLINK_PRIMARY?: string;
  WL_COLOR_HYPERLINK_PRIMARY_VISITED?: string;
  WL_COLOR_HYPERLINK_ACCENT: string;
  WL_COLOR_HYPERLINK_ACCENT_VISITED: string;
}

export interface BrandDark {
  BRAND_AWARE_TEXT: BrandAwareText;
  BRAND_INTERACTIVITY: BrandInteractivity;
  BRAND_AWARE_CLOSE_BUTTON: BrandAwareCloseButton;
  BRAND_UI_CONTROLS: BrandUIControls;
  BRAND_FALCON_INVEST: BrandFalconInvest;
  BRAND_WL_COLORS?: DarkBrandWlColors;
}

export interface BrandAwareCloseButton {
  WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: string;
  WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: string;
  WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: string;
}

export interface BrandAwareText {
  WL_COLOR_ONPRIMARY: string;
  WL_COLOR_ONACCENT: string;
}

export interface BrandFalconInvest {
  WL_APPLICATION_BODY_COLOR_BACKGROUND: string;
  WL_APPLICATION_HEADER_COLOR_BACKGROUND: string;
}

export interface BrandInteractivity {
  WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: string;
  WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: string;
  BRAND_BG_COLOR_PRESSED_PRIMARY: string;
  WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: string;
}

export interface BrandUIControls {
  WL_COLOR_CHECKBOXRADIOSWITCH_INNER: string;
}

export interface DarkBrandWlColors {
  WL_COLOR_BUTTON_TEXT_LINK_PRIMARY?: string;
}

export interface OutlineMinimalBtnOverrides {
  OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: string;
  OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: string;
}

export interface Core {
  LIGHT: CoreDark;
  DARK: CoreDark;
}

export interface CoreDark {
  BASE: DarkBase;
  BACKGROUND_COLOR: BackgroundColor;
  TEXT_COLOR: TextColor;
  BORDER_COLOR: BorderColor;
  OPACITIES: Opacities;
  NEUTRAL: Neutral;
  SHADOWS: Shadows;
  STATUS_COLORS: DarkStatusColors;
  TRADING_COLORS: TradingColors;
  ADMIN: Admin;
  MISC: Misc;
  ALERT_COLORS: AlertColors;
}

export interface Admin {
  COLOR_FIGMA_FAKE_ONEPERCENT_LIGHT: string;
  COLOR_FIGMA_FAKE_ONEPERCENT_DARK: string;
}

export interface AlertColors {
  ALERT_COLOR_BACKGROUND_SUCCESS: string;
  ALERT_COLOR_TEXT_SUCCESS: string;
  ALERT_COLOR_BACKGROUND_INFO: string;
  ALERT_COLOR_TEXT_INFO: string;
  ALERT_COLOR_BACKGROUND_ERROR: string;
  ALERT_COLOR_TEXT_ERROR: string;
  ALERT_COLOR_BACKGROUND_WARNING: string;
  ALERT_COLOR_TEXT_WARNING: string;
}

export interface BackgroundColor {
  COLOR_BACKGROUND: string;
  APPLICATION_BGS: ApplicationBgs;
  COLOR_BACKGROUND_WIDGET: string;
  INTERACTIVE_STATES_BG: InteractiveStatesBg;
  INPUT_COLOR_BACKGROUND_DISABLED: string;
  MENUITEM_COLOR_BACKGROUND_PARENT: string;
  PANEL_COLOR_BACKGROUND: string;
  INPUT_COLOR_BACKGROUND: string;
  SWITCH_COLOR_BACKGROUND: string;
  HIGHLIGHTED_CELLS: HighlightedCells;
  SECONDARY_BASE: SecondaryBase;
}

export interface ApplicationBgs {
  APPHEADER_COLOR_BACKGROUND: string;
  APPBODY_COLOR_BACKGROUND: string;
}

export interface HighlightedCells {
  TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_ERROR: string;
  TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_INFO: string;
  TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_SUCCESS: string;
  TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_WARNING: string;
}

export interface InteractiveStatesBg {
  TABLE_ROW_COLOR_BACKGROUND_HOVER: string;
  TABLE_ROW_COLOR_BACKGROUND_SELECTED: string;
  COLOR_BACKGROUND_TINT_HOVER_DARK: string;
  COLOR_BACKGROUND_TINT_HOVER_LIGHT: string;
  COLOR_BACKGROUND_TINT_PRESSED_DARK: string;
  COLOR_BACKGROUND_TINT_PRESSED_LIGHT: string;
  COLOR_BACKGROUND_TINT_HOVER_DARK_NOSWITCH: string;
  COLOR_BACKGROUND_TINT_PRESSED_DARK_NOSWITCH: string;
  COLOR_BACKGROUND_TINT_HOVER_LIGHT_NOSWITCH: string;
  COLOR_BACKGROUND_TINT_PRESSED_LIGHT_NOSWITCH: string;
  COLOR_BACKGROUND_TINT_HOVER_DARK_SOFT: string;
  COLOR_BACKGROUND_TINT_HOVER_LIGHT_SOFT: string;
  COLOR_BACKGROUND_TINT_PRESSED_DARK_SOFT: string;
  COLOR_BACKGROUND_TINT_PRESSED_LIGHT_SOFT: string;
  TAB_COLOR_BACKGROUND_SECONDARY_ACTIVE: string;
}

export interface SecondaryBase {
  COLOR_BACKGROUND_SECONDARYBASE: string;
  COLOR_BACKGROUND_SECONDARYBASE_INVERTED: string;
}

export interface DarkBase {
  BLACK: string;
  WHITE: string;
  BLACK_NOSWITCH: string;
  WHITE_NOSWITCH: string;
}

export interface BorderColor {
  COLOR_BORDER_DARK: string;
  COLOR_BORDER_DEFAULT: string;
  COLOR_BORDER_LIGHT: string;
  COLOR_BORDER_ULTRALIGHT: string;
  COLOR_BORDER_ULTRALIGHT_NOSWITCH: string;
  COLOR_BORDER_ERROR: string;
  COLOR_BORDER_ERROR_FOCUS: string;
  COLOR_BORDER_DISABLED: string;
}

export interface Misc {
  COLOR_YELLOW: string;
}

export interface Neutral {
  COLOR_NEUTRAL_900: string;
  COLOR_NEUTRAL_800: string;
  COLOR_NEUTRAL_700: string;
  COLOR_NEUTRAL_600: string;
  COLOR_NEUTRAL_500: string;
  COLOR_NEUTRAL_400: string;
  COLOR_NEUTRAL_300: string;
  COLOR_NEUTRAL_200: string;
  COLOR_NEUTRAL_100: string;
  COLOR_NEUTRAL_50: string;
  COLOR_NEUTRAL_35: string;
  COLOR_NEUTRAL_25: string;
  COLOR_NEUTRAL_15: string;
  COLOR_NEUTRAL_05: string;
}

export interface Opacities {
  COLOR_DARK_OPACITY_90: string;
  COLOR_DARK_OPACITY_85: string;
  COLOR_DARK_OPACITY_75: string;
  COLOR_DARK_OPACITY_70: string;
  COLOR_DARK_OPACITY_70_NOSWITCH: string;
  COLOR_DARK_OPACITY_60: string;
  COLOR_DARK_OPACITY_60_NOSWITCH: string;
  COLOR_DARK_OPACITY_50: string;
  COLOR_DARK_OPACITY_50_NOSWITCH: string;
  COLOR_DARK_OPACITY_30: string;
  COLOR_DARK_OPACITY_20: string;
  COLOR_DARK_OPACITY_20_NOSWITCH: string;
  COLOR_DARK_OPACITY_16: string;
  COLOR_DARK_OPACITY_15: string;
  COLOR_DARK_OPACITY_10: string;
  COLOR_DARK_OPACITY_10_NOSWITCH: string;
  COLOR_DARK_OPACITY_8: string;
  COLOR_DARK_OPACITY_6: string;
  COLOR_DARK_OPACITY_5: string;
  COLOR_DARK_OPACITY_4: string;
  COLOR_DARK_OPACITY_3: string;
  COLOR_DARK_OPACITY_2: string;
  COLOR_DARK_OPACITY_1: string;
  COLOR_DARK_OPACITY_0: string;
  COLOR_LIGHT_OPACITY_90: string;
  COLOR_LIGHT_OPACITY_85: string;
  COLOR_LIGHT_OPACITY_75: string;
  COLOR_LIGHT_OPACITY_70: string;
  COLOR_LIGHT_OPACITY_70_NOSWITCH: string;
  COLOR_LIGHT_OPACITY_60: string;
  COLOR_LIGHT_OPACITY_60_NOSWITCH: string;
  COLOR_LIGHT_OPACITY_50: string;
  COLOR_LIGHT_OPACITY_50_NOSWITCH: string;
  COLOR_LIGHT_OPACITY_30: string;
  COLOR_LIGHT_OPACITY_20: string;
  COLOR_LIGHT_OPACITY_20_NOSWITCH: string;
  COLOR_LIGHT_OPACITY_16: string;
  COLOR_LIGHT_OPACITY_15: string;
  COLOR_LIGHT_OPACITY_10: string;
  COLOR_LIGHT_OPACITY_10_NOSWITCH: string;
  COLOR_LIGHT_OPACITY_8: string;
  COLOR_LIGHT_OPACITY_6: string;
  COLOR_LIGHT_OPACITY_5: string;
  COLOR_LIGHT_OPACITY_4: string;
  COLOR_LIGHT_OPACITY_3: string;
  COLOR_LIGHT_OPACITY_2: string;
  COLOR_LIGHT_OPACITY_1: string;
  COLOR_LIGHT_OPACITY_0: string;
}

export interface DarkStatusColors {
  ERROR: Error;
  SUCCESS: Success;
  INFO: Info;
  WARNING: Warning;
}

export interface Error {
  COLOR_ERROR_800: string;
  COLOR_ERROR_700: string;
  COLOR_ERROR_600: string;
  COLOR_ERROR_500: string;
  COLOR_ERROR_400: string;
  COLOR_ERROR_50: string;
  COLOR_ERROR_25: string;
}

export interface Info {
  COLOR_INFO_800: string;
  COLOR_INFO_700: string;
  COLOR_INFO_600: string;
  COLOR_INFO_500: string;
  COLOR_INFO_400: string;
  COLOR_INFO_50: string;
  COLOR_INFO_25: string;
}

export interface Success {
  COLOR_SUCCESS_800: string;
  COLOR_SUCCESS_700: string;
  COLOR_SUCCESS_600: string;
  COLOR_SUCCESS_500: string;
  COLOR_SUCCESS_400: string;
  COLOR_SUCCESS_200: string;
  COLOR_SUCCESS_50: string;
  COLOR_SUCCESS_25: string;
}

export interface Warning {
  COLOR_WARNING_800: string;
  COLOR_WARNING_700: string;
  COLOR_WARNING_600: string;
  COLOR_WARNING_500: string;
  COLOR_WARNING_400: string;
  COLOR_WARNING_50: string;
  COLOR_WARNING_25: string;
}

export interface TextColor {
  COLOR_TEXT_DARK: string;
  COLOR_TEXT_DEFAULT: string;
  COLOR_TEXT_DEFAULT_NOSWITCH: string;
  COLOR_TEXT_LIGHT: string;
  COLOR_TEXT_ERROR: string;
  COLOR_TEXT_DISABLED: string;
  COLOR_TEXT_DISABLED_NOSWITCH: string;
  COLOR_TEXT_LINK_WCAG: string;
}

export interface TradingColors {
  COLOR_TRADING_POSITIVE: string;
  COLOR_TRADING_NEGATIVE: string;
  COLOR_TRADING_POSITIVE_DARK: string;
  COLOR_TRADING_NEGATIVE_DARK: string;
}

export const EORA_COLOURS: IEoraColours = {
  BASE: {
    VALUE: {
      COLOR: {
        OPAQUE_BLUES: {
          BLUE_500_OPACITY_50: '#2E90FA1A',
          BLUE_500_OPACITY_70: '#2E90FA33'
        },
        STATUS_COLORS: {
          ORANGE: {
            ORANGE_25: '#FEF4E7',
            ORANGE_50: '#FDE8CD',
            ORANGE_400: '#F8A63A',
            ORANGE_500: '#F79009',
            ORANGE_600: '#AD6301',
            ORANGE_700: '#945605',
            ORANGE_800: '#633903'
          },
          BLUE: {
            BLUE_25: '#EBF4FE',
            BLUE_50: '#D5E8FE',
            BLUE_400: '#58A6FB',
            BLUE_500: '#2E90FA',
            BLUE_600: '#2473C8',
            BLUE_700: '#1B5696',
            BLUE_800: '#123964'
          },
          RED: {
            RED_800: '#601B16',
            RED_25: '#FDEDEC',
            RED_50: '#FCD9D7',
            RED_400: '#F36960',
            RED_500: '#EA1B0C',
            RED_600: '#C0362C',
            RED_700: '#902821'
          },
          GREEN: {
            GREEN_25: '#E8F8F0',
            GREEN_50: '#CFF0E1',
            GREEN_200: '#00E001',
            GREEN_400: '#42C588',
            GREEN_500: '#12B76A',
            GREEN_600: '#0F874F',
            GREEN_700: '#0A6D3F',
            GREEN_800: '#07492A'
          }
        },
        BRAND: {
          CMC_ONLY: {
            CMC_COBALT: '#445F74',
            CMC_CORAL: '#FF5757',
            CMC_GREY_FOUNDATION: '#EAEBEB'
          },
          WL_COLORS: {
            CMC_PRIMARY: '#0070F0',
            CMC_ACCENT: '#0C163C',
            CMC_LINK: '#0070F0',
            CMC_PRIMARY_WCAG: '#70A8E9',
            CMC_ACCENT_WCAG: '#0C163C',
            CMC_FOCUS: '#0070F080',
            BENDIGO_PRIMARY: '#DE313B',
            BENDIGO_ACCENT: '#58003A',
            BENDIGO_LINK: '#DE313B',
            BENDIGO_PRIMARY_WCAG: '#DE313B',
            BENDIGO_ACCENT_WCAG: '#58003A',
            BENDIGO_FOCUS: '#DE313B80',
            STGEORGE_PRIMARY: '#E30000',
            STGEORGE_ACCENT: '#008739',
            STGEORGE_LINK: '#E30000',
            STGEORGE_PRIMARY_WCAG: '#E30000',
            STGEORGE_ACCENT_WCAG: '#008739',
            STGEORGE_FOCUS: '#E3000080',
            EBROKING_PRIMARY: '#186BA5',
            EBROKING_ACCENT: '#415676',
            EBROKING_LINK: '#186BA5',
            EBROKING_PRIMARY_WCAG: '#186BA5',
            EBROKING_ACCENT_WCAG: '#415676',
            EBROKING_FOCUS: '#186BA580',
            BOQ_PRIMARY: '#1B75BC',
            BOQ_ACCENT: '#FEBD36',
            BOQ_LINK: '#1B75BC',
            BOQ_PRIMARY_WCAG: '#1B75BC',
            BOQ_ACCENT_WCAG: '#FEBD36',
            BOQ_FOCUS: '#1B75BC80',
            ADVANTAGE_PRIMARY: '#18BD9C',
            ADVANTAGE_ACCENT: '#403E43',
            ADVANTAGE_LINK: '#01856A',
            ADVANTAGE_PRIMARY_WCAG: '#01856A',
            ADVANTAGE_ACCENT_WCAG: '#403E43',
            ADVANTAGE_FOCUS: '#18BD9C80',
            RIVKIN_PRIMARY: '#072D60',
            RIVKIN_ACCENT: '#000000',
            RIVKIN_LINK: '#000000',
            RIVKIN_PRIMARY_WCAG: '#072D60',
            RIVKIN_ACCENT_WCAG: '#000000',
            RIVKIN_FOCUS: '#072D6080',
            ALPHA_PRIMARY: '#986E43',
            ALPHA_ACCENT: '#000000',
            ALPHA_LINK: '#006DCC',
            ALPHA_PRIMARY_WCAG: '#000000',
            ALPHA_ACCENT_WCAG: '#986E43',
            ALPHA_FOCUS: '#986E4380',
            UK_PRIMARY: '#00573F',
            UK_ACCENT: '#BFE276',
            UK_LINK: '#00573F',
            UK_PRIMARY_WCAG: '#00573F',
            UK_ACCENT_WCAG: '#BFE276',
            UK_FOCUS: '#00573F80',
            ASB_PRIMARY: '#0064AD',
            ASB_ACCENT: '#FFC20E',
            ASB_LINK: '#0064AD',
            ASB_PRIMARY_WCAG: '#0064AD',
            ASB_ACCENT_WCAG: '#FFC20E',
            ASB_FOCUS: '#0064AD80',
            ASB_PRIMARY_2: '#FCBD1B',
            ASB_ACCENT_2: '#0064AC',
            ASB_LINK_2: '#0064AC',
            ASB_PRIMARY_WCAG_2: '#FCBD1B',
            ASB_ACCENT_WCAG_2: '#0064AC',
            ASB_FOCUS_2: '#FCBD1B80',
            MARKETS_PRIMARY: '#0070F0',
            MARKETS_ACCENT: '#0C163C',
            MARKETS_LINK: '#0070F0',
            MARKETS_PRIMARY_WCAG: '#0070F0',
            MARKETS_ACCENT_WCAG: '#0C163C',
            MARKETS_FOCUS: '#0070F080',
            CONNECT_PRIMARY: '#FF4C21',
            CONNECT_ACCENT: '#101626',
            CONNECT_LINK: '#FF4C21',
            CONNECT_PRIMARY_WCAG: '#FF4C21',
            CONNECT_ACCENT_WCAG: '#101626',
            CONNECT_FOCUS: '#FF4C2180',
            GSB_PRIMARY: '#99D9D5',
            GSB_ACCENT: '#00384D',
            GSB_LINK: '#99D9D5',
            GSB_PRIMARY_WCAG: '#99D9D5',
            GSB_ACCENT_WCAG: '#00384D',
            GSB_FOCUS: '#99D9D580',
            WESTPAC_PRIMARY: '#DA1710',
            WESTPAC_ACCENT: '#1F1C4F',
            WESTPAC_LINK: '#DA1710',
            WESTPAC_PRIMARY_WCAG: '#DA1710',
            _WESTPAC_ACCENT_WCAG: '#1F1C4F',
            WESTPAC_FOCUS: '#1F1C4F80'
          }
        },
        GRAY: {
          GRAY_05: '#FDFDFD',
          GRAY_15: '#F7F7F7',
          GRAY_25: '#F1F1F1',
          GRAY_35: '#ECECEC',
          GRAY_50: '#E2E2E2',
          GRAY_100: '#D5D5D5',
          GRAY_200: '#C6C6C6',
          GRAY_300: '#A9A9A9',
          GRAY_400: '#8D8D8D',
          GRAY_500: '#717171',
          GRAY_600: '#5A5A5A',
          GRAY_700: '#434343',
          GRAY_800: '#1C1C1E',
          GRAY_900: '#222222'
        },
        BASE: { WHITE: '#FFFFFF', BLACK: '#000000' },
        MISC: {
          YELLOW: '#FFCD00',
          SHADOW_SOFT: '#091E4226',
          SHADOW_DEFAULT: '#091E4233',
          SHADOW_STRONG: '#091E4240',
          SHADOW_XSTRONG: '#091E424D'
        },
        TRADING: {
          TRADING_RED: '#EB0F29',
          TRADING_GREEN: '#00873C',
          TRADING_GREEN_DARK: '#017B37',
          TRADING_RED_DARK: '#D6011A',
          TRADING_RED_DARKMODE: '#FF4A60',
          TRADING_GREEN_DARKMODE: '#00E001',
          TRADING_GREEN_DARKMODE_DARK: '#0F874F',
          TRADING_RED_DARKMODE_DARK: '#FF4A60'
        }
      }
    }
  },
  CORE: {
    LIGHT: {
      BASE: {
        BLACK: '#000000',
        WHITE: '#FFFFFF',
        BLACK_NOSWITCH: '#000000',
        WHITE_NOSWITCH: '#FFFFFF'
      },
      BACKGROUND_COLOR: {
        COLOR_BACKGROUND: '#F7F7F7',
        APPLICATION_BGS: {
          APPHEADER_COLOR_BACKGROUND: '#ECECEC',
          APPBODY_COLOR_BACKGROUND: '#F7F7F7'
        },
        COLOR_BACKGROUND_WIDGET: '#FFFFFF',
        INTERACTIVE_STATES_BG: {
          TABLE_ROW_COLOR_BACKGROUND_HOVER: '#2E90FA1A',
          TABLE_ROW_COLOR_BACKGROUND_SELECTED: '#2E90FA33',
          COLOR_BACKGROUND_TINT_HOVER_DARK: '#0000001A',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT: '#FFFFFF1A',
          COLOR_BACKGROUND_TINT_PRESSED_DARK: '#00000033',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT: '#FFFFFF33',
          COLOR_BACKGROUND_TINT_HOVER_DARK_NOSWITCH: '#0000001A',
          COLOR_BACKGROUND_TINT_PRESSED_DARK_NOSWITCH: '#00000033',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT_NOSWITCH: '#FFFFFF1A',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT_NOSWITCH: '#FFFFFF33',
          COLOR_BACKGROUND_TINT_HOVER_DARK_SOFT: '#00000008',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT_SOFT: '#FFFFFF08',
          COLOR_BACKGROUND_TINT_PRESSED_DARK_SOFT: '#0000000F',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT_SOFT: '#FFFFFF0F',
          TAB_COLOR_BACKGROUND_SECONDARY_ACTIVE: '#000000B3'
        },
        INPUT_COLOR_BACKGROUND_DISABLED: '#F7F7F7',
        MENUITEM_COLOR_BACKGROUND_PARENT: '#0000000F',
        PANEL_COLOR_BACKGROUND: '#FFFFFF',
        INPUT_COLOR_BACKGROUND: '#FFFFFF',
        SWITCH_COLOR_BACKGROUND: '#D5D5D5',
        HIGHLIGHTED_CELLS: {
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_ERROR: '#FCD9D7',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_INFO: '#D5E8FE',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_SUCCESS: '#CFF0E1',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_WARNING: '#FDE8CD'
        },
        SECONDARY_BASE: {
          COLOR_BACKGROUND_SECONDARYBASE: '#0000001A',
          COLOR_BACKGROUND_SECONDARYBASE_INVERTED: '#FFFFFF1A'
        }
      },
      TEXT_COLOR: {
        COLOR_TEXT_DARK: '#000000',
        COLOR_TEXT_DEFAULT: '#222222',
        COLOR_TEXT_DEFAULT_NOSWITCH: '#222222',
        COLOR_TEXT_LIGHT: '#717171',
        COLOR_TEXT_ERROR: '#EA1B0C',
        COLOR_TEXT_DISABLED: '#717171',
        COLOR_TEXT_DISABLED_NOSWITCH: '#717171',
        COLOR_TEXT_LINK_WCAG: '#0070F0'
      },
      BORDER_COLOR: {
        COLOR_BORDER_DARK: '#717171',
        COLOR_BORDER_DEFAULT: '#A9A9A9',
        COLOR_BORDER_LIGHT: '#D5D5D5',
        COLOR_BORDER_ULTRALIGHT: '#F1F1F1',
        COLOR_BORDER_ULTRALIGHT_NOSWITCH: '#F1F1F1',
        COLOR_BORDER_ERROR: '#EA1B0C',
        COLOR_BORDER_ERROR_FOCUS: '#EA1B0C80',
        COLOR_BORDER_DISABLED: '#D5D5D5'
      },
      OPACITIES: {
        COLOR_DARK_OPACITY_90: '#000000E6',
        COLOR_DARK_OPACITY_85: '#000000D9',
        COLOR_DARK_OPACITY_75: '#000000BF',
        COLOR_DARK_OPACITY_70: '#000000B3',
        COLOR_DARK_OPACITY_70_NOSWITCH: '#000000B3',
        COLOR_DARK_OPACITY_60: '#00000099',
        COLOR_DARK_OPACITY_60_NOSWITCH: '#00000099',
        COLOR_DARK_OPACITY_50: '#00000080',
        COLOR_DARK_OPACITY_50_NOSWITCH: '#00000080',
        COLOR_DARK_OPACITY_30: '#0000004D',
        COLOR_DARK_OPACITY_20: '#00000033',
        COLOR_DARK_OPACITY_20_NOSWITCH: '#00000033',
        COLOR_DARK_OPACITY_16: '#00000029',
        COLOR_DARK_OPACITY_15: '#00000026',
        COLOR_DARK_OPACITY_10: '#0000001A',
        COLOR_DARK_OPACITY_10_NOSWITCH: '#0000001A',
        COLOR_DARK_OPACITY_8: '#00000014',
        COLOR_DARK_OPACITY_6: '#0000000F',
        COLOR_DARK_OPACITY_5: '#0000000D',
        COLOR_DARK_OPACITY_4: '#0000000A',
        COLOR_DARK_OPACITY_3: '#00000008',
        COLOR_DARK_OPACITY_2: '#00000005',
        COLOR_DARK_OPACITY_1: '#00000003',
        COLOR_DARK_OPACITY_0: '#00000000',
        COLOR_LIGHT_OPACITY_90: '#FFFFFFE6',
        COLOR_LIGHT_OPACITY_85: '#FFFFFFD9',
        COLOR_LIGHT_OPACITY_75: '#FFFFFFBF',
        COLOR_LIGHT_OPACITY_70: '#FFFFFFB3',
        COLOR_LIGHT_OPACITY_70_NOSWITCH: '#FFFFFFB3',
        COLOR_LIGHT_OPACITY_60: '#FFFFFF99',
        COLOR_LIGHT_OPACITY_60_NOSWITCH: '#FFFFFF99',
        COLOR_LIGHT_OPACITY_50: '#FFFFFF80',
        COLOR_LIGHT_OPACITY_50_NOSWITCH: '#FFFFFF80',
        COLOR_LIGHT_OPACITY_30: '#FFFFFF4D',
        COLOR_LIGHT_OPACITY_20: '#FFFFFF33',
        COLOR_LIGHT_OPACITY_20_NOSWITCH: '#FFFFFF33',
        COLOR_LIGHT_OPACITY_16: '#FFFFFF29',
        COLOR_LIGHT_OPACITY_15: '#FFFFFF26',
        COLOR_LIGHT_OPACITY_10: '#FFFFFF1A',
        COLOR_LIGHT_OPACITY_10_NOSWITCH: '#FFFFFF1A',
        COLOR_LIGHT_OPACITY_8: '#FFFFFF14',
        COLOR_LIGHT_OPACITY_6: '#FFFFFF0F',
        COLOR_LIGHT_OPACITY_5: '#FFFFFF0D',
        COLOR_LIGHT_OPACITY_4: '#FFFFFF0A',
        COLOR_LIGHT_OPACITY_3: '#FFFFFF08',
        COLOR_LIGHT_OPACITY_2: '#FFFFFF05',
        COLOR_LIGHT_OPACITY_1: '#FFFFFF03',
        COLOR_LIGHT_OPACITY_0: '#FFFFFF00'
      },
      NEUTRAL: {
        COLOR_NEUTRAL_900: '#222222',
        COLOR_NEUTRAL_800: '#1C1C1E',
        COLOR_NEUTRAL_700: '#434343',
        COLOR_NEUTRAL_600: '#5A5A5A',
        COLOR_NEUTRAL_500: '#717171',
        COLOR_NEUTRAL_400: '#8D8D8D',
        COLOR_NEUTRAL_300: '#A9A9A9',
        COLOR_NEUTRAL_200: '#C6C6C6',
        COLOR_NEUTRAL_100: '#D5D5D5',
        COLOR_NEUTRAL_50: '#E2E2E2',
        COLOR_NEUTRAL_35: '#ECECEC',
        COLOR_NEUTRAL_25: '#F1F1F1',
        COLOR_NEUTRAL_15: '#F7F7F7',
        COLOR_NEUTRAL_05: '#FDFDFD'
      },
      SHADOWS: {
        SHADOW_SOFT: '#091E4226',
        SHADOW_DEFAULT: '#091E4233',
        SHADOW_STRONG: '#091E4240',
        SHADOW_XSTRONG: '#091E424D',
        Z_IGNORE: { XS_IGNORE: '#0000004D' }
      },
      STATUS_COLORS: {
        ERROR: {
          COLOR_ERROR_800: '#601B16',
          COLOR_ERROR_700: '#902821',
          COLOR_ERROR_600: '#C0362C',
          COLOR_ERROR_500: '#EA1B0C',
          COLOR_ERROR_400: '#F36960',
          COLOR_ERROR_50: '#FCD9D7',
          COLOR_ERROR_25: '#FDEDEC'
        },
        SUCCESS: {
          COLOR_SUCCESS_800: '#07492A',
          COLOR_SUCCESS_700: '#0A6D3F',
          COLOR_SUCCESS_600: '#0F874F',
          COLOR_SUCCESS_500: '#12B76A',
          COLOR_SUCCESS_400: '#42C588',
          COLOR_SUCCESS_200: '#00E001',
          COLOR_SUCCESS_50: '#CFF0E1',
          COLOR_SUCCESS_25: '#E8F8F0'
        },
        INFO: {
          COLOR_INFO_800: '#123964',
          COLOR_INFO_700: '#1B5696',
          COLOR_INFO_600: '#2473C8',
          COLOR_INFO_500: '#2E90FA',
          COLOR_INFO_400: '#58A6FB',
          COLOR_INFO_50: '#D5E8FE',
          COLOR_INFO_25: '#EBF4FE'
        },
        WARNING: {
          COLOR_WARNING_800: '#633903',
          COLOR_WARNING_700: '#945605',
          COLOR_WARNING_600: '#AD6301',
          COLOR_WARNING_500: '#F79009',
          COLOR_WARNING_400: '#F8A63A',
          COLOR_WARNING_50: '#FDE8CD',
          COLOR_WARNING_25: '#FEF4E7'
        }
      },
      TRADING_COLORS: {
        COLOR_TRADING_POSITIVE: '#00873C',
        COLOR_TRADING_NEGATIVE: '#EB0F29',
        COLOR_TRADING_POSITIVE_DARK: '#017B37',
        COLOR_TRADING_NEGATIVE_DARK: '#D6011A'
      },
      ADMIN: {
        COLOR_FIGMA_FAKE_ONEPERCENT_LIGHT: '#FFFFFF03',
        COLOR_FIGMA_FAKE_ONEPERCENT_DARK: '#00000003'
      },
      MISC: { COLOR_YELLOW: '#FFCD00' },
      ALERT_COLORS: {
        ALERT_COLOR_BACKGROUND_SUCCESS: '#E8F8F0',
        ALERT_COLOR_TEXT_SUCCESS: '#0A6D3F',
        ALERT_COLOR_BACKGROUND_INFO: '#EBF4FE',
        ALERT_COLOR_TEXT_INFO: '#1B5696',
        ALERT_COLOR_BACKGROUND_ERROR: '#FDEDEC',
        ALERT_COLOR_TEXT_ERROR: '#902821',
        ALERT_COLOR_BACKGROUND_WARNING: '#FEF4E7',
        ALERT_COLOR_TEXT_WARNING: '#945605'
      }
    },
    DARK: {
      BASE: {
        BLACK: '#FFFFFF',
        WHITE: '#000000',
        BLACK_NOSWITCH: '#000000',
        WHITE_NOSWITCH: '#FFFFFF'
      },
      BACKGROUND_COLOR: {
        COLOR_BACKGROUND: '#1C1C1E',
        APPLICATION_BGS: {
          APPHEADER_COLOR_BACKGROUND: '#1C1C1E',
          APPBODY_COLOR_BACKGROUND: '#000000'
        },
        COLOR_BACKGROUND_WIDGET: '#000000',
        INTERACTIVE_STATES_BG: {
          TABLE_ROW_COLOR_BACKGROUND_HOVER: '#FFFFFF1A',
          TABLE_ROW_COLOR_BACKGROUND_SELECTED: '#FFFFFF26',
          COLOR_BACKGROUND_TINT_HOVER_DARK: '#FFFFFF1A',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT: '#0000001A',
          COLOR_BACKGROUND_TINT_PRESSED_DARK: '#FFFFFF33',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT: '#00000033',
          COLOR_BACKGROUND_TINT_HOVER_DARK_NOSWITCH: '#0000001A',
          COLOR_BACKGROUND_TINT_PRESSED_DARK_NOSWITCH: '#00000033',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT_NOSWITCH: '#FFFFFF1A',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT_NOSWITCH: '#FFFFFF33',
          COLOR_BACKGROUND_TINT_HOVER_DARK_SOFT: '#FFFFFF08',
          COLOR_BACKGROUND_TINT_HOVER_LIGHT_SOFT: '#00000008',
          COLOR_BACKGROUND_TINT_PRESSED_DARK_SOFT: '#FFFFFF0F',
          COLOR_BACKGROUND_TINT_PRESSED_LIGHT_SOFT: '#0000000F',
          TAB_COLOR_BACKGROUND_SECONDARY_ACTIVE: '#FFFFFFB3'
        },
        INPUT_COLOR_BACKGROUND_DISABLED: '#1C1C1E',
        MENUITEM_COLOR_BACKGROUND_PARENT: '#FFFFFF0F',
        PANEL_COLOR_BACKGROUND: '#1C1C1E',
        INPUT_COLOR_BACKGROUND: '#000000',
        SWITCH_COLOR_BACKGROUND: '#5A5A5A',
        HIGHLIGHTED_CELLS: {
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_ERROR: '#601B16',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_INFO: '#D5E8FE',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_SUCCESS: '#07492A',
          TABLE_CELL_COLOR_BACKGROUND_HIGHLIGHT_WARNING: '#FDE8CD'
        },
        SECONDARY_BASE: {
          COLOR_BACKGROUND_SECONDARYBASE: '#FFFFFF33',
          COLOR_BACKGROUND_SECONDARYBASE_INVERTED: '#0000001A'
        }
      },
      TEXT_COLOR: {
        COLOR_TEXT_DARK: '#FFFFFF',
        COLOR_TEXT_DEFAULT: '#FDFDFD',
        COLOR_TEXT_DEFAULT_NOSWITCH: '#222222',
        COLOR_TEXT_LIGHT: '#A9A9A9',
        COLOR_TEXT_ERROR: '#EA1B0C',
        COLOR_TEXT_DISABLED: '#A9A9A9',
        COLOR_TEXT_DISABLED_NOSWITCH: '#717171',
        COLOR_TEXT_LINK_WCAG: '#70A8E9'
      },
      BORDER_COLOR: {
        COLOR_BORDER_DARK: '#E2E2E2',
        COLOR_BORDER_DEFAULT: '#C6C6C6',
        COLOR_BORDER_LIGHT: '#8D8D8D',
        COLOR_BORDER_ULTRALIGHT: '#434343',
        COLOR_BORDER_ULTRALIGHT_NOSWITCH: '#F1F1F1',
        COLOR_BORDER_ERROR: '#EA1B0C',
        COLOR_BORDER_ERROR_FOCUS: '#EA1B0C80',
        COLOR_BORDER_DISABLED: '#8D8D8D'
      },
      OPACITIES: {
        COLOR_DARK_OPACITY_90: '#FFFFFFE6',
        COLOR_DARK_OPACITY_85: '#FFFFFFD9',
        COLOR_DARK_OPACITY_75: '#FFFFFFBF',
        COLOR_DARK_OPACITY_70: '#FFFFFFB3',
        COLOR_DARK_OPACITY_70_NOSWITCH: '#000000B3',
        COLOR_DARK_OPACITY_60: '#FFFFFF99',
        COLOR_DARK_OPACITY_60_NOSWITCH: '#00000099',
        COLOR_DARK_OPACITY_50: '#FFFFFF80',
        COLOR_DARK_OPACITY_50_NOSWITCH: '#00000080',
        COLOR_DARK_OPACITY_30: '#FFFFFF4D',
        COLOR_DARK_OPACITY_20: '#FFFFFF33',
        COLOR_DARK_OPACITY_20_NOSWITCH: '#00000033',
        COLOR_DARK_OPACITY_16: '#FFFFFF29',
        COLOR_DARK_OPACITY_15: '#FFFFFF26',
        COLOR_DARK_OPACITY_10: '#FFFFFF1A',
        COLOR_DARK_OPACITY_10_NOSWITCH: '#0000001A',
        COLOR_DARK_OPACITY_8: '#FFFFFF14',
        COLOR_DARK_OPACITY_6: '#FFFFFF0F',
        COLOR_DARK_OPACITY_5: '#FFFFFF0D',
        COLOR_DARK_OPACITY_4: '#FFFFFF0A',
        COLOR_DARK_OPACITY_3: '#FFFFFF08',
        COLOR_DARK_OPACITY_2: '#FFFFFF05',
        COLOR_DARK_OPACITY_1: '#FFFFFF03',
        COLOR_DARK_OPACITY_0: '#FFFFFF00',
        COLOR_LIGHT_OPACITY_90: '#000000E6',
        COLOR_LIGHT_OPACITY_85: '#000000D9',
        COLOR_LIGHT_OPACITY_75: '#000000BF',
        COLOR_LIGHT_OPACITY_70: '#000000B3',
        COLOR_LIGHT_OPACITY_70_NOSWITCH: '#FFFFFFB3',
        COLOR_LIGHT_OPACITY_60: '#00000099',
        COLOR_LIGHT_OPACITY_60_NOSWITCH: '#FFFFFF99',
        COLOR_LIGHT_OPACITY_50: '#00000080',
        COLOR_LIGHT_OPACITY_50_NOSWITCH: '#FFFFFF80',
        COLOR_LIGHT_OPACITY_30: '#0000004D',
        COLOR_LIGHT_OPACITY_20: '#00000033',
        COLOR_LIGHT_OPACITY_20_NOSWITCH: '#FFFFFF33',
        COLOR_LIGHT_OPACITY_16: '#00000029',
        COLOR_LIGHT_OPACITY_15: '#00000026',
        COLOR_LIGHT_OPACITY_10: '#0000001A',
        COLOR_LIGHT_OPACITY_10_NOSWITCH: '#FFFFFF1A',
        COLOR_LIGHT_OPACITY_8: '#00000014',
        COLOR_LIGHT_OPACITY_6: '#0000000F',
        COLOR_LIGHT_OPACITY_5: '#0000000D',
        COLOR_LIGHT_OPACITY_4: '#0000000A',
        COLOR_LIGHT_OPACITY_3: '#00000008',
        COLOR_LIGHT_OPACITY_2: '#00000005',
        COLOR_LIGHT_OPACITY_1: '#00000003',
        COLOR_LIGHT_OPACITY_0: '#00000000'
      },
      NEUTRAL: {
        COLOR_NEUTRAL_900: '#FDFDFD',
        COLOR_NEUTRAL_800: '#F7F7F7',
        COLOR_NEUTRAL_700: '#F1F1F1',
        COLOR_NEUTRAL_600: '#ECECEC',
        COLOR_NEUTRAL_500: '#E2E2E2',
        COLOR_NEUTRAL_400: '#D5D5D5',
        COLOR_NEUTRAL_300: '#C6C6C6',
        COLOR_NEUTRAL_200: '#A9A9A9',
        COLOR_NEUTRAL_100: '#8D8D8D',
        COLOR_NEUTRAL_50: '#717171',
        COLOR_NEUTRAL_35: '#5A5A5A',
        COLOR_NEUTRAL_25: '#434343',
        COLOR_NEUTRAL_15: '#1C1C1E',
        COLOR_NEUTRAL_05: '#222222'
      },
      SHADOWS: {
        SHADOW_SOFT: '#000000',
        SHADOW_DEFAULT: '#000000',
        SHADOW_STRONG: '#000000',
        SHADOW_XSTRONG: '#000000',
        Z_IGNORE: { XS_IGNORE: '#FFFFFF4D' }
      },
      STATUS_COLORS: {
        ERROR: {
          COLOR_ERROR_800: '#601B16',
          COLOR_ERROR_700: '#902821',
          COLOR_ERROR_600: '#C0362C',
          COLOR_ERROR_500: '#EA1B0C',
          COLOR_ERROR_400: '#F36960',
          COLOR_ERROR_50: '#FCD9D7',
          COLOR_ERROR_25: '#FDEDEC'
        },
        SUCCESS: {
          COLOR_SUCCESS_800: '#07492A',
          COLOR_SUCCESS_700: '#0A6D3F',
          COLOR_SUCCESS_600: '#0F874F',
          COLOR_SUCCESS_500: '#12B76A',
          COLOR_SUCCESS_400: '#42C588',
          COLOR_SUCCESS_200: '#00E001',
          COLOR_SUCCESS_50: '#CFF0E1',
          COLOR_SUCCESS_25: '#E8F8F0'
        },
        INFO: {
          COLOR_INFO_800: '#123964',
          COLOR_INFO_700: '#1B5696',
          COLOR_INFO_600: '#2473C8',
          COLOR_INFO_500: '#2E90FA',
          COLOR_INFO_400: '#58A6FB',
          COLOR_INFO_50: '#D5E8FE',
          COLOR_INFO_25: '#EBF4FE'
        },
        WARNING: {
          COLOR_WARNING_800: '#633903',
          COLOR_WARNING_700: '#945605',
          COLOR_WARNING_600: '#AD6301',
          COLOR_WARNING_500: '#F79009',
          COLOR_WARNING_400: '#F8A63A',
          COLOR_WARNING_50: '#FDE8CD',
          COLOR_WARNING_25: '#FEF4E7'
        }
      },
      TRADING_COLORS: {
        COLOR_TRADING_POSITIVE: '#00E001',
        COLOR_TRADING_NEGATIVE: '#FF4A60',
        COLOR_TRADING_POSITIVE_DARK: '#0F874F',
        COLOR_TRADING_NEGATIVE_DARK: '#FF4A60'
      },
      ADMIN: {
        COLOR_FIGMA_FAKE_ONEPERCENT_LIGHT: '#00000003',
        COLOR_FIGMA_FAKE_ONEPERCENT_DARK: '#FFFFFF03'
      },
      MISC: { COLOR_YELLOW: '#FFCD00' },
      ALERT_COLORS: {
        ALERT_COLOR_BACKGROUND_SUCCESS: '#0A6D3F',
        ALERT_COLOR_TEXT_SUCCESS: '#FFFFFF',
        ALERT_COLOR_BACKGROUND_INFO: '#1B5696',
        ALERT_COLOR_TEXT_INFO: '#FFFFFF',
        ALERT_COLOR_BACKGROUND_ERROR: '#902821',
        ALERT_COLOR_TEXT_ERROR: '#FFFFFF',
        ALERT_COLOR_BACKGROUND_WARNING: '#945605',
        ALERT_COLOR_TEXT_WARNING: '#FFFFFF'
      }
    }
  },
  BRAND: {
    CMC: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#0070F0',
        WL_COLOR_ACCENT: '#0C163C',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#0C163C',
        WL_COLOR_HYPERLINK_PRIMARY: '#0070F0',
        WL_COLOR_HYPERLINK_PRIMARY_VISITED: '#0070F0',
        WL_COLOR_HYPERLINK_ACCENT: '#0C163C',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#0C163C'
      },
      DARK: {
        BRAND_WL_COLORS: { WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#70A8E9' },
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: { WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#0070F0' },
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#0070F080' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#0070F0',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#0C163C'
      }
    },
    BENDIGO: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#DE313B',
        WL_COLOR_ACCENT: '#58003A',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#DE313B',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#58003A',
        WL_COLOR_HYPERLINK_ACCENT: '#58003A',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#58003A'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#DE313B80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#DE313B',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#58003A'
      }
    },
    ST_GEORGE: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#E30000',
        WL_COLOR_ACCENT: '#008739',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#E30000',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#008739',
        WL_COLOR_HYPERLINK_ACCENT: '#008739',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#008739'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#E3000080' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#E30000',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#008739'
      }
    },
    BOQ: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#1B75BC',
        WL_COLOR_ACCENT: '#FEBD36',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#1B75BC',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#FEBD36',
        WL_COLOR_HYPERLINK_ACCENT: '#FEBD36',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#FEBD36'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#1B75BC80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#1B75BC',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#FEBD36'
      }
    },
    RIVKIN: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#072D60',
        WL_COLOR_ACCENT: '#000000',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#072D60',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#000000',
        WL_COLOR_HYPERLINK_ACCENT: '#000000',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#000000'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#072D6080' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#072D60',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#000000'
      }
    },
    ADVANTAGE: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#18BD9C',
        WL_COLOR_ACCENT: '#403E43',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#18BD9C',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#403E43',
        WL_COLOR_HYPERLINK_PRIMARY: '#01856A',
        WL_COLOR_HYPERLINK_PRIMARY_VISITED: '#01856A',
        WL_COLOR_HYPERLINK_ACCENT: '#403E43',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#403E43'
      },
      DARK: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#18BD9C80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#18BD9C',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#403E43'
      }
    },
    E_BROKING: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#186BA5',
        WL_COLOR_ACCENT: '#415676',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#186BA5',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#415676',
        WL_COLOR_HYPERLINK_ACCENT: '#415676',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#415676'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#186BA580' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#186BA5',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#415676'
      }
    },
    ALPHA: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#986E43',
        WL_COLOR_ACCENT: '#000000',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#986E43',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#000000',
        WL_COLOR_HYPERLINK_PRIMARY: '#006DCC',
        WL_COLOR_HYPERLINK_PRIMARY_VISITED: '#006DCC',
        WL_COLOR_HYPERLINK_ACCENT: '#000000',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#000000'
      },
      DARK: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#986E4380' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#986E43',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#000000'
      }
    },
    UK: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#00573F',
        WL_COLOR_ACCENT: '#BFE276',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#00573F',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#BFE276',
        WL_COLOR_HYPERLINK_ACCENT: '#BFE276',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#BFE276'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#00573F80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#00573F',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#1C1917'
      }
    },
    ASB: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#0064AD',
        WL_COLOR_ACCENT: '#FFC20E',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#0064AD',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#FFC20E',
        WL_COLOR_HYPERLINK_ACCENT: '#FFC20E',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#FFC20E'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#FFFFFF1A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#FFFFFF33',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#000000'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#FFFFFF1A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#FFFFFF33',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#0064AD80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#0064AD',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#FFC20E'
      }
    },
    ASB_2: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#FCBD1B',
        WL_COLOR_ACCENT: '#0064AC',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#FCBD1B',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#0064AC',
        WL_COLOR_HYPERLINK_ACCENT: '#0064AC',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#0064AC'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#FCBD1B80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#FCBD1B',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#0064AC'
      }
    },
    MARKETS_CMC: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#0070F0',
        WL_COLOR_ACCENT: '#0C163C',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#0070F0',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#0C163C',
        WL_COLOR_HYPERLINK_PRIMARY: '#0070F0',
        WL_COLOR_HYPERLINK_PRIMARY_VISITED: '#0070F0',
        WL_COLOR_HYPERLINK_ACCENT: '#0C163C',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#0C163C'
      },
      DARK: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#FFFFFF1A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#FFFFFF33',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#FFFFFF1A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#0000001A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#FFFFFF33',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#0070F080' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#0070F0',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#0C163C'
      }
    },
    CONNECT: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#FF4C21',
        WL_COLOR_ACCENT: '#101626',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#FF4C21',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#101626',
        WL_COLOR_HYPERLINK_ACCENT: '#101626',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#101626'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#0000001A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#00000033'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#0070F080' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#0070F0',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#0C163C'
      }
    },
    GREAT_SOUTHERN_BANK: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#99D9D5',
        WL_COLOR_ACCENT: '#00384D',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#99D9D5',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#00384D',
        WL_COLOR_HYPERLINK_ACCENT: '#00384D',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#00384D'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#000000',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#000000',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#99D9D580' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#99D9D5',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#00384D'
      }
    },
    WESTPAC: {
      BRAND_CMC_ONLY_COLORS: {
        CMC_COLOR_COBALT: '#445F74',
        CMC_COLOR_CORAL: '#FF5757',
        CMC_COLOR_GRAYFOUNDATION: '#EAEBEB'
      },
      BRAND_WL_COLORS: {
        WL_COLOR_PRIMARY: '#DA1710',
        WL_COLOR_ACCENT: '#1F1C4F',
        WL_COLOR_BUTTON_TEXT_LINK_PRIMARY: '#DA1710',
        WL_COLOR_BUTTON_TEXT_LINK_ACCENT: '#1F1C4F',
        WL_COLOR_HYPERLINK_ACCENT: '#1F1C4F',
        WL_COLOR_HYPERLINK_ACCENT_VISITED: '#1F1C4F'
      },
      DARK: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#0000001A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#00000033',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#00000033'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#000000',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#1C1C1E'
        }
      },
      LIGHT: {
        BRAND_WL_COLORS: {},
        BRAND_AWARE_TEXT: {
          WL_COLOR_ONPRIMARY: '#FFFFFF',
          WL_COLOR_ONACCENT: '#FFFFFF'
        },
        BRAND_INTERACTIVITY: {
          WL_COLOR_BACKGROUND_TINT_PRIMARY_HOVER: '#FFFFFF1A',
          WL_COLOR_BACKGROUND_TINT_ACCENT_HOVER: '#FFFFFF1A',
          BRAND_BG_COLOR_PRESSED_PRIMARY: '#FFFFFF33',
          WL_COLOR_BACKGROUND_TINT_ACCENT_PRESSED: '#FFFFFF33'
        },
        BRAND_AWARE_CLOSE_BUTTON: {
          WL_CLOSEBUTTON_COLOR_TEXT_ONPRIMARY: '#FFFFFF',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_HOVER: '#FFFFFF1A',
          WL_CLOSEBUTTON_COLOR_BACKGROUND_ONPRIMARY_PRESSED: '#FFFFFF33'
        },
        BRAND_UI_CONTROLS: { WL_COLOR_CHECKBOXRADIOSWITCH_INNER: '#FFFFFF' },
        BRAND_FALCON_INVEST: {
          WL_APPLICATION_BODY_COLOR_BACKGROUND: '#F7F7F7',
          WL_APPLICATION_HEADER_COLOR_BACKGROUND: '#ECECEC'
        }
      },
      BRAND_FOCUS_RING: { WL_COLOR_FOCUSRING: '#1F1C4F80' },
      OUTLINE_MINIMAL_BTN_OVERRIDES: {
        OUTLINEMINIMALPRIMARYBUTTON_COLOR_TEXT: '#DA1710',
        OUTLINEMINIMALACCENTBUTTON_COLOR_TEXT: '#1F1C4F'
      }
    }
  }
} as const;

export type EuroaColours = typeof EORA_COLOURS;
export type EuroaColour = EuroaColours[keyof EuroaColours];
